import React from "react";
import TrainingContentList from "./TrainingContentList";

const DriverTraining = () => {
  return (
    <TrainingContentList
      category="driver-training"
      title="Driver Training"
      breadcrumbs={["Training Library", "Driver Training"]}
    />
  );
};

export default DriverTraining;
